const category = {
  attendance: 'Behavior & Participation',
  progresstest: 'Test Results',
  unitreport: 'unitReport',
  progressreport: 'progressReport',
};

export default category;



// WEBPACK FOOTER //
// ./containers/Student/Note/category.jsx